import { gql } from '@apollo/client'

export const LEGAL_STATUS_FRAGMENT = gql`
  fragment LegalStatusFragment on LegalStatus {
    id
    name
    commonName
    isMicro
  }
`
